export default __webpack_public_path__ + "static/media/p3.e44a7bd3.jpg";